  $(document).on('click', '.main_wear_it .custom-add-to-cart .btn-add', function () {
    var linee = $(this).data('id');
    console.log(linee);
    addItemNeww(linee)
  });

  function addItemNeww(linee) {
    let data = {
     'items': [{
      'id': linee,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
        setTimeout(()=>{
            $('body').addClass('open-drawer')
        },500);

      })
      .catch((error) => {
          console.error('Error:', error);
    });
  }



// setInterval(function(){
//   if(document.querySelector('.drawer-footer') != null){
// var toRemoveHeights = parseInt(document.querySelector('.drawer-footer').offsetHeight) + parseInt(document.querySelector('.drawer-header').offsetHeight) + 26;
// var remainingHeights = parseInt(window.innerHeight) - toRemoveHeights;
  
// document.querySelector('.drawer-middle').style.height = remainingHeights + 'px';
//     }
// }, 100);


function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;
      var isFreeGift = cartRemove.hasAttribute('data-free-gift-remove');
      cartRemove.addEventListener('click',(evt) => {
        if (isFreeGift) { sessionStorage.setItem('freeGiftDismissed', 'true'); }
        removeItem(data_line);
      });
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
      if($(window).width() < 768){
        $('body').attr( 'data-pos', $(window).scrollTop()); // get actual scrollpos
         $('body').scrollTop( $('body').attr( 'data-pos' ) ); 
        $('body').addClass('locked'); // add class to body
      }

        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
         $('.shiping_info .list').infiniteslide({
          'speed': 50,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
          });
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
         if($(window).width() < 768){
          $("body").removeClass('locked');
          $(window).scrollTop( $('body').attr( 'data-pos' ));
          }
        setTimeout(function() {
          document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
        },200)
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      handleFreeGift(data);
      var cart_count = data.item_count;
      var option_color = '';
      var option_size = '';
      if(data.items.length > 0 && data.items[0].final_price != undefined){
         var option_price = Shopify.formatMoney(data.items[0].final_price); 
      data.items[0].options_with_values.forEach(function (option) {
        if(option.name == "Color") {
          option_color = option.value;
        }
        if(option.name == "Size") {
          option_size = option.value; 
        }
      });

      }
      if(cart_count>0){
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = '(' + cart_count + ')';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = cart_count;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.add('active');
      }else{
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = '(0)';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = 0;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.remove('active');
      }
    })
    .catch(function(error) {
      console.log(error);
    })
    updateCartDrawerUSPs();
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// --- Free gift -------------------------------------------------------------
// Auto-adds the configured gift once the cart subtotal (excluding the gift)
// reaches the threshold, and auto-removes it if the cart drops back below it.
// If the shopper removes the gift themselves, it stays out for the current
// session and a "claim" button is shown instead of re-adding it.
function handleFreeGift(cart) {
  const giftEl = document.querySelector('[data-free-gift]');
  if (!giftEl) return;

  const variantId = parseInt(giftEl.getAttribute('data-variant-id'), 10);
  const threshold = parseInt(giftEl.getAttribute('data-threshold'), 10);
  if (!variantId || !threshold) return;

  const giftItem = cart.items.find(item => item.id === variantId);
  const giftInCart = !!giftItem;
  // Measure against the pre-discount cart value so a running sale (the
  // stapelkorting or any other automatic discount) doesn't push the gift out of
  // reach. Outside of sale periods original_total_price === total_price.
  // Keep this in sync with the free gift block in sections/cart-drawer.liquid.
  const cartTotal = cart.original_total_price || cart.total_price;
  const giftLineTotal = giftInCart ? (giftItem.original_line_price || giftItem.final_line_price) : 0;
  const totalExclGift = cartTotal - giftLineTotal;
  const eligible = totalExclGift >= threshold;
  let dismissed = sessionStorage.getItem('freeGiftDismissed') === 'true';

  // Reset the dismissal once the cart drops below the threshold, so the gift
  // can be offered again next time it is reached.
  if (!eligible && dismissed) {
    sessionStorage.removeItem('freeGiftDismissed');
    dismissed = false;
  }

  if (eligible && !giftInCart && !dismissed) {
    addFreeGift(variantId);
    return;
  }

  if (!eligible && giftInCart) {
    const lineIndex = cart.items.findIndex(item => item.id === variantId);
    if (lineIndex !== -1) removeFreeGiftLine(lineIndex + 1);
    return;
  }

  // Eligible but the shopper removed it: reveal the "claim" button.
  giftEl.classList.toggle('cart-free-gift--dismissed', eligible && !giftInCart && dismissed);
}

function addFreeGift(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
  .then((response) => response.json())
  .then(() => load_cart())
  .catch((error) => console.error('Error:', error));
}

function removeFreeGiftLine(line) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: 0 }),
  })
  .then((response) => response.json())
  .then(() => load_cart())
  .catch((error) => console.error('Error:', error));
}


$(document).ready(function () {

  $(document).on('click', '.cart-free-gift-claim', function () {
    var variantId = parseInt($(this).closest('[data-free-gift]').attr('data-variant-id'), 10);
    sessionStorage.removeItem('freeGiftDismissed');
    if (variantId) addFreeGift(variantId);
  });

  $(document).on('click', '.main-upsell .add-btn', function () {
    $(this).hide();
    $(this).parents('.top-upsell').next('.bottom-upsell').slideDown();
  });
  $(document).on('click', '.upsell-var .var', function () {
    $(this).addClass('active').siblings().removeClass('active');
    var id = $(this).data('id');
    $(this).parents('.upsell-var').next().attr("data-id",id);
  });
  $(document).on('click', '.singal-upsell .main-btn', function () {
    var line = $(this).data('id');
    addItemNew(line)
  });

  function addItemNew(line) {
    let data = {
     'items': [{
      'id': line,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
      })
      .catch((error) => {
          console.error('Error:', error);
    });
  }

  

  $(document).on('change','.center_qty .cart_qty', function() {
   var new_qty = $(this).val();
    var line = $(this).parent('.center_qty').siblings('.item_minus').data('line-item')
   addItem(line,new_qty); 
 });

  $(document).on('click', '.item_plus', function () {
      setTimeout(() => {
        $('.shiping_info .list').infiniteslide({
          'speed': 50,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
        });
      }, "1500")
      $(this).prev('.center_qty').find('input').val(+$(this).prev('.center_qty').find('input').val() + 1);
      var new_line = $(this).data('line-item')
      var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
      addItem(new_line, new_qty);
  });
  $(document).on('click', '.item_minus', function () {
      setTimeout(() => {
        $('.shiping_info .list').infiniteslide({
          'speed': 50,
          'direction': 'left',
          'pauseonhover': true,
          'responsive': false,
          'clone': 2
        });
      }, "1500")
      if ($(this).next('.center_qty').find('input').val() > 0) $(this).next('.center_qty').find('input').val(+$(this).next('.center_qty').find('input').val() - 1);
      var new_line = $(this).data('line-item')
      var new_qty = $(this).closest('.main_qty').find('input.cart_qty').val();
      addItem(new_line, new_qty);
  });

// ===
  if($(".quantity-box input")) {
    $(document).on('change','.quantity-box input', function() {
      var new_line = $(this).attr("data-index");
      var new_qty = $(this).val();
      addItem(new_line, new_qty);
    });
  }
  // var quanity_box = document.querySelectorAll('.quantity-box');
  // var update_button = document.querySelector('.button-update');
  // if(quanity_box){
  //   quanity_box.forEach(function(quantitywrap){
  //     var quantity_minus = quantitywrap.querySelector(".quantity-minus");
  //     var quantity_add = quantitywrap.querySelector(".quantity-plus");
  //     var quantity = quantitywrap.querySelector(".quantity-input input");
  //     const minimum = 0;
  //     if(quantity_minus){
  //       quantity_minus.addEventListener("click", function(){
  //         if (quantity.value <= minimum) {
  //           quantity_minus.disabled = true;
  //           return;
  //         } else {
  //           quantity_minus.disabled = false;
  //         }
  //         quantity.value--;
  //         if(update_button){
  //           update_button.click();
  //         }
  //       });
  //     }
  //     if(quantity_add){
  //       quantity_add.addEventListener("click", function() {
  //         if (quantity.value > minimum) {
  //           quantity_minus.disabled = false;
  //         }
  //         quantity.value++;
  //         if(update_button){
  //           update_button.click();
  //         }
  //       });
  //     }
  //   });
  // }
  // ===

  
  function addItem(new_line, new_qty) {
      const data = { 'line': new_line, 'quantity': new_qty };
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
      })
      .catch((error) => {
          console.error('Error:', error);
      });
  }

  // setInterval(function(){
  //   if(document.querySelector('.drawer-footer') != null){
  //   var toRemoveHeights = parseInt(document.querySelector('.drawer-footer').offsetHeight) + parseInt(document.querySelector('.drawer-header').offsetHeight) + 26;
  //   var remainingHeights = parseInt(window.innerHeight) - toRemoveHeights;
  //   document.querySelector('.drawer-middle').style.height = remainingHeights + 'px';
  //     }
  // }, 100);
  
})





var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '€1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



let uspCountdownInterval;

function updateCartDrawerUSPs() {
  function getCETDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }

  // Same-day shipping cut-off (CET) from theme settings, defaults to 20:00
  const uspDeliveryEl = document.querySelector('.cart-drawer-usp .usp.delivery');
  const cutoffHour = uspDeliveryEl ? parseInt(uspDeliveryEl.dataset.cutoffHour, 10) : NaN;
  const cutoffMinute = uspDeliveryEl ? parseInt(uspDeliveryEl.dataset.cutoffMinute, 10) : NaN;

  function getCountdownToCutoff() {
    const now = getCETDate();
    const target = new Date(now);
    target.setHours(isNaN(cutoffHour) ? 20 : cutoffHour, isNaN(cutoffMinute) ? 0 : cutoffMinute, 0, 0);
    const diffMs = Math.max(target - now, 0);
    const hours = String(Math.floor(diffMs / (1000 * 60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
    const seconds = String(Math.floor((diffMs % (1000 * 60)) / 1000)).padStart(2, '0');
    return { time: `${hours}:${minutes}:${seconds}`, expired: now >= target };
  }

  function getReturnDate() {
    const now = getCETDate();
    now.setDate(now.getDate() + 31);
    const day = now.getDate();
    const month = now.toLocaleString('en-GB', { month: 'long' });
    return `${day} ${month}`;
  }

  function isAfterMidnight() {
    const now = getCETDate();
    return now.getHours() === 0 && now.getMinutes() === 0 && now.getSeconds() < 2;
  }

  function getTodayString() {
    const now = getCETDate();
    return now.toISOString().slice(0, 10);
  }

  if (uspCountdownInterval) {
    clearInterval(uspCountdownInterval);
    uspCountdownInterval = null;
  }

  const uspDeliverySpan = document.querySelector('.cart-drawer-usp .usp.delivery span');
  const uspDeliveryDiv = uspDeliverySpan ? uspDeliverySpan.closest('.usp') : null;
  const hiddenKey = 'uspDeliveryHiddenDate';
  const today = getTodayString();
  const hiddenDate = localStorage.getItem(hiddenKey);

  if (uspDeliverySpan && uspDeliveryDiv) {
    if (hiddenDate === today) {
      uspDeliveryDiv.style.display = 'none';
    } else {
      uspDeliveryDiv.style.display = '';
      let lastTime = '';
      function updateCountdown() {
        const { time, expired } = getCountdownToCutoff();
        if (uspDeliverySpan.innerHTML.indexOf(time) === -1) {
          uspDeliverySpan.innerHTML = uspDeliverySpan.innerHTML.replace(/\d{2}:\d{2}:\d{2}|(\[time\])/g, time);
        }
        if (expired) {
          uspDeliveryDiv.style.display = 'none';
          localStorage.setItem(hiddenKey, today);
          clearInterval(uspCountdownInterval);
          uspCountdownInterval = null;
        }
      }
      uspDeliverySpan.innerHTML = uspDeliverySpan.innerHTML.replace('[time]', getCountdownToCutoff().time);
      updateCountdown();
      uspCountdownInterval = setInterval(updateCountdown, 1000);
    }
    if (hiddenDate === today && isAfterMidnight()) {
      localStorage.removeItem(hiddenKey);
      uspDeliveryDiv.style.display = '';
      uspDeliverySpan.innerHTML = uspDeliverySpan.innerHTML.replace(/\d{2}:\d{2}:\d{2}|(\[time\])/g, getCountdownToCutoff().time);
      uspCountdownInterval = setInterval(() => {
        const { time, expired } = getCountdownToCutoff();
        if (uspDeliverySpan.innerHTML.indexOf(time) === -1) {
          uspDeliverySpan.innerHTML = uspDeliverySpan.innerHTML.replace(/\d{2}:\d{2}:\d{2}|(\[time\])/g, time);
        }
        if (expired) {
          uspDeliveryDiv.style.display = 'none';
          localStorage.setItem(hiddenKey, getTodayString());
          clearInterval(uspCountdownInterval);
          uspCountdownInterval = null;
        }
      }, 1000);
    }
  }

  // Update returns USP as before
  const uspReturns = document.querySelectorAll('.cart-drawer-usp .usp span')[1];
  if (uspReturns) {
    uspReturns.innerHTML = uspReturns.innerHTML.replace('[date]', getReturnDate());
  }
}